// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"csNBH"};